<template>
  <ol class="raw-body-3 text-[var(--raw-darkgrey)]">
    <li v-for="(source, index) in sources" :key="index" :value="numbers[index]">
      <span data-marker>{{ numbers[index] }}</span>
      <InlineMarkdown :message="source" />
    </li>
  </ol>
</template>

<script setup lang="ts">
import InlineMarkdown from '~/scopes/campaign/components/UI/InlineMarkdown.vue'
import type { I18nDescriptor } from '~/scopes/campaign/data/metals/types'

// Numbered study mentions; the marker matches the superscripts a metal's prose prints. Each
// entry accepts the same inline markdown-lite as prose, so a `[label](url)` reference links
// to its source.
//
// `numbers` is caller-supplied, never positional: the bibliography prints the client's
// official numbers — which are also the metals' markers — so retiring an entry must not
// renumber the rest. `value` on the `<li>` keeps the ordinals right for assistive tech,
// since the marker is rendered rather than a native list bullet.
defineProps<{
  sources: I18nDescriptor[]
  numbers: number[]
}>()
</script>

<style scoped>
ol {
  display: grid;
  gap: 0.375rem;
  list-style: none;

  /* A citation prints its URL as the link's own text, and most run well past 100
       characters with nothing to break on. `anywhere` rather than `break-word`: both
       break the token visually, but only `anywhere` lets those break points count
       toward min-content, so the grid track can actually shrink instead of setting a
       floor that pushes the panel into horizontal scroll. */
  overflow-wrap: anywhere;

  li {
    line-height: 1.2;

    [data-marker] {
      font-size: 75%;
      vertical-align: top;
      margin-right: 0.25rem;
    }
  }
}
</style>
